import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {RouterModule} from '@angular/router';
import {AppSharedModule} from '../app-shared.module';
import {EditorTextoComponent} from './editor-texto/editor-texto.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {NavbarComponent} from './navbar/navbar.component';
import { ArquivoVisualizadorComponent } from './arquivo-visualizador/arquivo-visualizador.component';
import { IdComponent } from './id/id.component';
import { RotuloComponent } from './rotulo/rotulo.component';
import { IdService } from './id/id.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AppSharedModule
  ],
  exports: [
    ArquivoVisualizadorComponent,
    EditorTextoComponent,
    FooterComponent,
    SidebarComponent,
    NavbarComponent,
    IdComponent,
    RotuloComponent
  ],
  declarations: [
    ArquivoVisualizadorComponent,
    FooterComponent,
    EditorTextoComponent,
    NavbarComponent,
    SidebarComponent,
    IdComponent,
    RotuloComponent
  ],
  providers: [
    IdService,
  ]
})
export class ComponentsModule { }
